module.exports = "<svg viewBox=\"0 0 20 20\"><path fill=\"#231F20\" d=\"M19 11H1c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.5 1-1 1z\"></path><path fill=\"#231F20\" d=\"M10 20c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v18c0 .5-.5 1-1 1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/cross.svg
// module id = 296
// module chunks = 1